import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {Log, cookie} from '@/util'

import zh from './zh_CN'
import en from './en_US'
import ja from './ja_JP'
// import ru from './ru_RU'
// import hi from './hi_IN'
// import ur from './ur_UR'
// import ko from './ko_KR'
// import th from './th_TH'
// import it from './it_IT'
// import de from './de_DE'
// import es from './es_ES'
// import fr from './fr_FR'

Vue.use(VueI18n)
const LanguageCodeList = Object.freeze({ zh: 1, en: 2, ja: 8 }) // fr: 3, es: 4, ru: 5, hi: 6, ur: 7, ko: 9, th: 10, de: 11, it: 12
const messages = Object.freeze({ 1: zh, 2: en, 8: ja }) // 3: fr, 4: es, 5: ru, 6: hi, 7: ur, 9: ko, 10: th, 11: de, 12: it
const languageCookieName = 'i18nLanguage'
const defaultLanguageCode = LanguageCodeList.en
let currBowerLanguage = (navigator.language || navigator.browserLanguage).toLowerCase()
let currentLanguageCode
const getCurrentLanguageCode = () => {
  // if (!cookie.get(languageCookieName)) {
    currentLanguageCode = cookie.get(languageCookieName)
  // }
  if(currentLanguageCode == null){
    if(currBowerLanguage.indexOf('zh') >=0 ){
      currentLanguageCode = LanguageCodeList.zh
    }else if(currBowerLanguage.indexOf('ja') >=0 ){
      currentLanguageCode = LanguageCodeList.ja
    }else if(window.navigator.language == 'en' && !currentLanguageCode){
      currentLanguageCode = LanguageCodeList.en
    }
    cookie.set(languageCookieName,currentLanguageCode)
  }
  if (!checkLanguageCode(currentLanguageCode)) {
    currentLanguageCode = defaultLanguageCode
  }
  // console.log(currentLanguageCode);
  return currentLanguageCode
}

const checkLanguageCode = (code) => {
  if (messages[code] === undefined) {
    currentLanguageCode = LanguageCodeList.en
    Log.e(`the language code(${code}) should be in ${Object.keys(messages).join(',')}`)
    return false
  }
  return true
}

const setCurrentLanguageCode = (vm, targetLanguageCode) => {
  // check
  if (!(vm instanceof Vue)) {
    throw new Error(`vm(${vm}) should be a Vue instance.`)
  }
  if (!checkLanguageCode(targetLanguageCode)) {
    throw new Error(`targetLanguageCode(${targetLanguageCode}) should be in ${Object.keys(messages).join(',')}`)
  }

  cookie.set(languageCookieName, vm.$i18n.locale = currentLanguageCode = targetLanguageCode)
  window.location.reload()
}

const i18n = new VueI18n({
  locale: getCurrentLanguageCode(),
  messages
})

export {
  i18n as default, LanguageCodeList, getCurrentLanguageCode, setCurrentLanguageCode
}
